import { atom } from "jotai";

export const OnboardingOpenAtom = atom(false);
